import { connectedStore } from '../../store';
import setSelection from '../actions/set-selection';
import getSelection from '../accessors/get-selection';

const triggerSelectionUpdate = () => {
  // This operation should be called when we need to imitate selection
  // update even though it might be same we are using it to re-render Control Pane triggers on purpose
  const store = connectedStore.get();
  const selection = getSelection();
  store.dispatch(setSelection({}));
  store.dispatch(setSelection(selection));
};

export default triggerSelectionUpdate;
